import { Record, Static, String } from 'runtypes'

export const Features = Record({
    name: String,
    value: String
})
export type IFeatures = Static<typeof Features>
